import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCurrentExchangeRates extends Layout {
    sourceCurrentExchangeRates: DataSource;
    tableExchangeRates: Table;
}
